// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2hYYz","footer":"ModalError_footer__290uF"};